import script from "./terminal-count.vue?vue&type=script&lang=ts&setup=true"
export * from "./terminal-count.vue?vue&type=script&lang=ts&setup=true"

import "./terminal-count.vue?vue&type=style&index=0&id=a621fa24&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a621fa24"]])

export default __exports__